import {getField, updateField} from "vuex-map-fields";
import {getNotificationState} from "@/store/States";

const state = getNotificationState()

const getters = {
    getSnackbarField(state) {
        return getField(state.snackbar);
    },
}

const actions = {}

const mutations = {
    resetState(state) {
        Object.assign(state, getNotificationState())
    },
    updateSnackbarField(state, field) {
        updateField(state.snackbar, field);
    },
    showSnackbar(state, {text, type}) {
        state.snackbar.text = text
        state.snackbar.type = type
        state.snackbar.show = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
